export const blue = 'rgb(34, 105, 163)';



// WEBPACK FOOTER //
// ./src/colours.js